import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { BreadcrumbsService } from 'src/app/services/utils/breadcrumbs.service';
import { PortOutService, PortOut, PortOutMessage } from 'src/app/services/api/port-out/port-out.service';
import { Title } from '@angular/platform-browser';
import { OrderStatusObject } from 'src/app/models/orders/order-status-object.model';
import { MatPaginator } from '@angular/material';
import { MatTableDataSource } from '@angular/material';

@Component({
  selector: 'app-port-out-detail',
  templateUrl: './port-out-detail.component.html',
  styleUrls: ['./port-out-detail.component.scss']
})
export class PortOutDetailComponent implements OnInit {

  portOut: PortOut;
  loading = true;

  messageDisplayedColumns: string[] = ['createdDate', 'message'];
  messagesDataSource = new MatTableDataSource<PortOutMessage>();
  copiedId: number = null;
  expandedIds = new Set<number>();
  arsErrorExpanded = false;
  arsErrorCopied = false;

  @ViewChild(MatPaginator, { static: false })
  set messagesPaginator(paginator: MatPaginator) {
    if (paginator) {
      this.messagesDataSource.paginator = paginator;
    }
  }

  constructor(
    private portOutService: PortOutService,
    private route: ActivatedRoute,
    private router: Router,
    private translate: TranslateService,
    private breadcrumbsService: BreadcrumbsService,
    private titleService: Title
  ) {}

  ngOnInit() {
    if (this.titleService.getTitle().includes(' - ')) {
      this.titleService.setTitle(this.titleService.getTitle().split(' - ')[1]);
    }
    this.breadcrumbsService.sendBreadcrumbs({
      breadcrumbs: [
        { title: 'Administración', url: 'provision/management' },
        { title: 'Portabilidades salientes', url: 'provision/management/port-out' },
        { title: 'Detalle', url: '' }
      ]
    });

    const id = +this.route.snapshot.queryParamMap.get('id');
    if (id) {
      this.portOutService.findById(id).subscribe(data => {
        if (data.messages) {
          data.messages = data.messages.sort((a, b) =>
            new Date(b.createdDate).getTime() - new Date(a.createdDate).getTime()
          );
        }
        this.portOut = data;
        this.messagesDataSource.data = data.messages || [];
        this.loading = false;
      }, () => {
        this.loading = false;
      });
    }
  }

  goBack() {
    this.router.navigate(['/provision/management/port-out']);
  }

  getPortOutStatus(status: string): OrderStatusObject {
    if (!status) { return new OrderStatusObject('', 'help', ''); }
    switch (status.toUpperCase()) {
      case 'CONFIGURED':
      case 'CHECKING':
      case 'CONFIGURING':  return new OrderStatusObject(status, 'settings', 'pending');
      case 'REQUESTED':    return new OrderStatusObject(status, 'send', 'inprogress');
      case 'ANSWERED':     return new OrderStatusObject(status, 'thumb_up', 'inprogress');
      case 'PROCESSING':   return new OrderStatusObject(status, 'access_time', 'inprogress');
      case 'PROCESSED':    return new OrderStatusObject(status, 'done_all', 'completed');
      case 'REGULARIZED':  return new OrderStatusObject(status, 'autorenew', 'completed');
      case 'FAILED':       return new OrderStatusObject(status, 'close', 'failed');
      case 'CANCELLED':    return new OrderStatusObject(status, 'cancel', 'cancelled');
      default:             return new OrderStatusObject(status, 'help', 'unknown');
    }
  }

  formatJson(raw: any): string {
    try {
      const obj = typeof raw === 'string' ? JSON.parse(raw) : raw;
      return JSON.stringify(obj, null, 2);
    } catch {
      return raw;
    }
  }

  copyJson(raw: any, messageId: number) {
    const text = this.formatJson(raw);
    navigator.clipboard.writeText(text).then(() => {
      this.copiedId = messageId;
      setTimeout(() => { this.copiedId = null; }, 2000);
    });
  }

  toggleExpand(messageId: number) {
    if (this.expandedIds.has(messageId)) {
      this.expandedIds.delete(messageId);
    } else {
      this.expandedIds.add(messageId);
    }
  }

  getJsonSummary(raw: any): string {
    try {
      const obj = typeof raw === 'string' ? JSON.parse(raw) : raw;
      const portability = obj && obj.portability ? obj.portability : null;
      const portOut = portability
        ? (portability['port-out'] || portability['portOut'] || portability['cancelled'] || {})
        : {};
      const parts: string[] = [];
      if (portOut.newStatus) { parts.push('newStatus: ' + portOut.newStatus); }
      if (portOut.oldStatus) { parts.push('oldStatus: ' + portOut.oldStatus); }
      if (portOut.msg)       { parts.push('msg: ' + portOut.msg); }
      return parts.length > 0 ? parts.join('  ·  ') : JSON.stringify(obj).substring(0, 80) + '...';
    } catch (e) {
      return String(raw).substring(0, 80) + '...';
    }
  }

  toggleArsErrorExpand() {
    this.arsErrorExpanded = !this.arsErrorExpanded;
  }

  copyArsError() {
    const text = this.formatJson(this.portOut.arsTerminationError);
    navigator.clipboard.writeText(text).then(() => {
      this.arsErrorCopied = true;
      setTimeout(() => { this.arsErrorCopied = false; }, 2000);
    });
  }

  getArsErrorSummary(): string {
    try {
      const obj = typeof this.portOut.arsTerminationError === 'string' 
        ? JSON.parse(this.portOut.arsTerminationError) 
        : this.portOut.arsTerminationError;
      const text = JSON.stringify(obj);
      return text.length > 100 ? text.substring(0, 100) + '...' : text;
    } catch (e) {
      const text = String(this.portOut.arsTerminationError);
      return text.length > 100 ? text.substring(0, 100) + '...' : text;
    }
  }
}
